// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3uiUJ","file":"styles_file__GJet5"};